























































import Vue from 'vue';
import * as richiedenteApi from '../services/richiedente-api';
import { RichiedenteList, RichiedenteListViewModel } from '../types';

export default Vue.extend({
    data(): RichiedenteListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.richiedente'),
                    value: 'displayName',
                },

                {
                    text: this.$i18n.t('labels.attivo'),
                    value: 'attivo',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await richiedenteApi.getList();
        },
        showDetail(item: RichiedenteList) {
            this.$router.push({
                name: 'RichiedenteDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await richiedenteApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
    },
    mounted() {
        this.loadData();
    },
    watch: {
        $route: {
            handler: async function () {
                await this.loadData();
            },
            deep: true,
        },
    },
});
